/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Boolean)],
  props: {
    mask: {type: Boolean, default: false},
    maskBlur: {type: Boolean, default: false},
    maskTarget: {type: String, default: '#modals'},
    zIndex: {type: Number, default: undefined},
    width: {
      type: [Number, String],
      default: 'max-content',
    },
    popperStyle: {
      type: [String, Object],
      default: 'padding: 0; border-radius: 0.8rem;'
    },
    popperOptions:{
      type: Object,
      default: Object
    },
    popperClass: {
      type: String,
      default: ''
    },
    placement: {
      type: String,
      default: 'bottom'
    },
    outsideExceptions: {
      type: Array,
      default: () => []
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    trigger: {
      type: String,
      default: 'click'
    },
    showAfter: {
      type: Number,
      default: 200
    },
    teleported: {
      type: Boolean,
      default: false
    },
    offset: {
      type: Number,
      default: undefined
    },
    transition: {
      type: String,
      default: undefined
    },
    title: {
      type: String,
      default: undefined
    },
    persistent: {
      type: Boolean,
      default: true
    },
    triggerKeys: {
      type: Array,
      default: () => []
    }
  },
  emits: ['hide', 'show', 'before-enter', 'after-leave'],
  data() {
    return {
      show_popover: false
    }
  },
  computed: {
    c_z_index() {
      if (this.mask && this.zIndex !== undefined) {
        return this.zIndex + 1
      }
      return this.zIndex
    },
    c_trigger() {
      return this.mask && this.trigger === 'hover' ? 'click' : this.trigger
    },
    c_teleported() {
      return this.mask || this.teleported
    },
    c_show_arrow() {
      return this.mask ? false : this.showArrow
    },
    popover_class() {
      return ['popover', this.mask && 'masked-popover', this.popperClass].filter(Boolean).join(' ')
    },
    visible: {
      get() {
        if (this.trigger !== 'click') {
          return undefined
        }
        return this.value
      },
      set(val) {
        this.value = val
      }
    }
  },
  methods: {
    onMaskClick() {
      if (this.trigger === 'click') {
        this.value = false
        return
      }
      this.hide()
    },
    onClickOutside(ev){
      try {
        if (ev?.target.closest?.('.modal-mask')) {
          return
        }
        if (ev && this.$refs.pp?.popperRef?.contentRef?.contains(ev.target)) {
          return
        }
        if (this.outsideExceptions.some(x => ev.target.closest(x))) {
          return
        }
        this.value = false

      } catch (error) {
        // 
      }
    },
    hide(){
      this.$refs.pp.hide()
    },
    beforeEnter(event){
      this.show_popover = true
      this.$emit('before-enter', event)
    },
    afterLeave(event){
      this.show_popover = false
      this.$emit('after-leave', event)
    }
  },
}
